module.exports = " <div class=header__dashboard _v-612bb15e=\"\"> <div class=header__logo _v-612bb15e=\"\"> <div class=container _v-612bb15e=\"\"> <a href=/ class=header__logo-link _v-612bb15e=\"\"> <img class=header__logo-image style=\"\" src=\"//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&amp;height=132\" alt=Aozama _v-612bb15e=\"\"> </a> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-612bb15e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/elements/header-dashboard.vue
// module id = 426
// module chunks = 0